const apiUrl = process.env.REACT_APP_API_URL;

const authProvider = {
  login: async ({ email, code }) => {
    const res = await fetch(`${apiUrl}/v1/admin/accounts/email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, code }),
    });
    if (!res.ok) throw new Error('Ошибка входа');
    const data = await res.json();
    localStorage.setItem('access_token', data.token);
  },
  logout: () => {
    localStorage.removeItem('access_token');
    return Promise.resolve();
  },
  checkAuth: () => localStorage.getItem('access_token') ? Promise.resolve() : Promise.reject(),
  checkError: ({ status }) => {
    if (status === 401 || status === 403) {
      localStorage.removeItem('access_token');
      return Promise.reject();
    }
    return Promise.resolve();
  },
  getPermissions: () => Promise.resolve(),
};
export default authProvider;
